export const appId = 'jvsMdkTzjo11tbKdhSD57TgL'
export const appSecret = 'buo2VrBQcNCxXspdzfGBhJiu'



// WEBPACK FOOTER //
// ./src/config/appKey.ts